module.exports = __webpack_public_path__ + "static/media/cash-for-junk-car.e799faa5.png";